import { QueryKey, useQuery, QueryResult, QueryConfig } from "react-query";
import { AxiosRequestConfig } from "axios";
import { stringify } from "query-string";
import api from "../index";
import { IProduct, ProductType } from "types/payments/Product";

export interface GetProductDetailsParams {
  product_type?: ProductType;
  currency?: string;
}

export const getProductDetails = async (
  params?: GetProductDetailsParams,
  options?: AxiosRequestConfig,
): Promise<IProduct[]> => {
  const { data } = await api.get<IProduct[]>(
    `/payments/product-details?${params ? stringify(params) : ""}`,
    options,
  );
  return data;
};

export const getProductDetailsQueryKey = () => [`payments/product-details`];

export const useProductDetails = (
  params?: GetProductDetailsParams,
  options?: {
    query?: QueryConfig<IProduct[], void>;
    request?: AxiosRequestConfig;
  },
): QueryResult<IProduct[], void> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options || {};
  const queryKey = queryOptions?.queryKey ?? getProductDetailsQueryKey();

  const queryFn = () => getProductDetails(params, requestOptions);

  const query = useQuery(queryKey, queryFn, {
    ...queryOptions,
    staleTime: 15 * 60 * 1000,
    cacheTime: 15 * 60 * 1000,
  });

  return {
    queryKey,
    ...query,
  };
};
